/* eslint-disable */
// -- Imports -- //
const onbrandUtilityFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); //Development options
const onbrand_scss = require('./onbrand.scss'); //Onbrand styles
const client_scss = require('./client/client.scss'); //client styles
const htmlHeader = require('./includes/header.html');
const htmlFooter = require('./includes/footer.html');
// -- Startup -- //
production ? null : onbrandUtilityFunctions.devMode(devOptions);
$('body').prepend(htmlHeader);
$('body').append(htmlFooter);
window.onbrandLoaded = false;
onbrandUtilityFunctions.helpfulClasses(); // Adds body classes for content type (blogPost, youtube, etc)
onbrandUtilityFunctions.fixShareWidgetImproved();
onbrandUtilityFunctions.noQueryStringSafeguard(); // warns you if your query string is missing.
// -- Custom Functions -- //
const dropdownOnHover = () => {
  const $headerli = $(
    '#injected-header > header > div > div.fusion-header > div > nav > ul > li > a'
  );
  $headerli.on('mouseenter', function(e) {
    $(this)
      .parent()
      .css('overflow', 'visible');
  });
};

// const openMobileNav = () => {
//   const $mobileMenu = $('#injected-header div.fusion-header div.fusion-mobile-menu-icons > a');
//   const $mobileNavLevel0 = $(
//     '#injected-header > header > div > div.fusion-header > div > nav.fusion-mobile-sticky-nav-holder'
//   );
//   const $mobileNavLevel0ul = $(
//     '#injected-header > header > div > div.fusion-header > div > nav.fusion-mobile-sticky-nav-holder >ul'
//   );
//   const $mobileNavLevel0Arrow = $(
//     '#injected-header > header > div > div.fusion-header > div > nav.fusion-mobile-nav-holder > ul > li > span'
//   );
//   const $mobileNavLevel0Link = $(
//     '#injected-header > header > div > div.fusion-header > div > nav.fusion-mobile-nav-holder > ul > li > a'
//   );

//   $mobileMenu.on('click', function(e) {
//     e.preventDefault();
//     if ($mobileNavLevel0.css('display') === 'none') {
//       $mobileNavLevel0.css('display', 'block');
//       $mobileNavLevel0ul.css('display', 'block');
//     } else {
//       $mobileNavLevel0.css('display', 'none');
//       $mobileNavLevel0ul.css('display', 'none');
//     }
//   });

//   $mobileNavLevel0Arrow.on('click', function() {
//     const $submenu = $(this)
//       .parent()
//       .find('ul.sub-menu');
//     if ($submenu.css('display') === 'none') {
//       $submenu.css('display', 'block');
//     } else {
//       $submenu.css('display', 'none');
//     }
//   });

//   $mobileNavLevel0Link.on('click', function() {
//     const $submenu = $(this)
//       .parent()
//       .find('ul.sub-menu');
//     if ($submenu.css('display') === 'none') {
//       $submenu.css('display', 'block');
//     } else {
//       $submenu.css('display', 'none');
//     }
//   });
// };

const closeHeaderDropdowns = () => {
  if ($(window).width() > 800) {
    const $mobileNavLevel0 = $(
      '#injected-header > header > div.fusion-header-v1.fusion-logo-left.fusion-sticky-menu-1.fusion-sticky-logo-1.fusion-mobile-logo-.fusion-mobile-menu-design-modern > div.fusion-header > div > nav.fusion-mobile-nav-holder.fusion-mobile-menu-text-align-left.fusion-mobile-sticky-nav-holder'
    );
    const $mobileNavLevel0ul = $(
      '#injected-header > header > div.fusion-header-v1.fusion-logo-left.fusion-sticky-menu-1.fusion-sticky-logo-1.fusion-mobile-logo-.fusion-mobile-menu-design-modern > div.fusion-header > div > nav.fusion-mobile-nav-holder.fusion-mobile-menu-text-align-left.fusion-mobile-sticky-nav-holder'
    );
    $mobileNavLevel0.css('display', 'none');
    $mobileNavLevel0ul.css('display', 'none');
  }
};

const hubSearchPlaceholder = () => {
  $('body  div.mobile-search-header > span.search-input > input[type="text"]').attr(
    'placeholder',
    'Type your search and press enter'
  );
};

const closeMobileResourceMenu = () => {
  if ($(window).width() > 930) {
    $('#left-nav-phone > div.mobile-nav').css('display', 'none');
  }
};

const hideSearch = () => {
  const $resourcesMenu = $('#left-nav-phone > div.mobile-nav');
  const $resourcesMenuButton = $('#top-header > div.top-nav > div > div > a.nav-toggle');
  const $closeIcon = $('#left-nav-phone > div > div.exit-bar > a.exit');
  const $searchIcon = $(
    '#top-header > div.top-nav > div > div > div.right-side-btns > div.relativeDiv.relativeDiv--search > div.search-container > div > span.search-icon > span'
  );
  if ($(window).width() < 930) {
    $resourcesMenuButton.on('click', function() {
      if ($resourcesMenu.css('display') === 'block') {
        $searchIcon.css('display', 'none');
      }
    });

    $closeIcon.on('click', function() {
      if ($resourcesMenu.css('display') === 'block') {
        $searchIcon.css('display', 'block');
      }
    });
  } else {
    $searchIcon.css('display', 'block');
  }
};

// OB-1315, OB-1303

const setDrawerHeight = () => {
  // let $footerScroll = 100;
  // Get the side nav
  const $sideNav = $('#left-nav > ul');
  $sideNav.css('top', '');
  // Get height of side navigation
  const $itemHeight = $sideNav.height();
  // Get height of window
  const $windowHeight = $(window).height();
  // Get height of entire document
  const $documentHeight = $(document).height();
  // Get height of footer
  const $footerHeight = $('#injected-footer').outerHeight();
  // Get height of header
  const $headerHeight = $('#injected-header').outerHeight();
  // Get the height of the stream template header
  const $streamHeader = $('#top-header').outerHeight();
  // Get the amount scrolled from the top
  const $windowScrollTop = $(window).scrollTop();
  // Calculates the amount scrolled into the footer
  const $footerScroll = $windowScrollTop - $documentHeight + $windowHeight + $footerHeight;
  // Calculate the height of the main content
  const $mainHeight = $('#hubs-container .page-aligner').outerHeight();
  const $sideNavPosition = $windowScrollTop + $headerHeight + $itemHeight;
  const itemLevelHeight =
    $('.bread-crumbs').outerHeight() +
    $('.item-data').outerHeight() +
    $('.related-items-container').outerHeight();
  const $sideNavContainer = $('#left-nav');
  $sideNavContainer.css({ float: 'left' });
  if (
    $sideNavPosition >= $headerHeight + $mainHeight + 65 ||
    $sideNavPosition >= $headerHeight + itemLevelHeight + 150
  ) {
    $sideNav.css({ position: 'absolute', bottom: '0px', top: ' ' });
  } else {
    $sideNav.css({ position: '', bottom: ' ', top: '90px' });
  }
};

const expandSearch = (function() {
  //create a default searchbar that we can clone - so that on page change top nav is not an empty element
  const $topNavOriginal = $('#top-header > div.top-nav').detach();

  // addResourceMenuText()
  return function() {
    const $topNav = $topNavOriginal.clone(true);
    const $searchToggle = $(
      '#top-header div.top-nav  div.right-side-btns div.search-container > div.search-toggle'
    );
    const $searchInput = $(
      '#top-header > div.top-nav div.right-side-btns span.search-input > input[type="text"]'
    );
    const $searchResultsClose = $(
      'body > div.search-results-overlay > div.mobile-search-header > span.search-close > span'
    );
    const $topNavClass = $('.top-nav');

    // Append top-nav to page aligner
    if ($(window).width() > 930) {
      $topNavClass.remove();
      if ($('.top-nav').length == 0) {
        $topNav.find('.page-width').removeClass('page-width');
        $topNav.find('.page-aligner').removeClass('page-aligner');
        $topNav.prependTo('.menu-home:first > ul');
        $('.search-toggle').addClass('expanded');
      }
    } else {
      // mobile view
      $topNavClass.remove();
      if ($('#top-header').children().length >= 1) {
        $topNav.appendTo('#top-header');
        $('#item-content > div.top-nav > div').addClass('page-width');
        $('#item-content > div.top-nav > div > div').addClass('page-aligner');
      }
    }
  };
})();

function thirdLevelMenu() {
  var activeMenu = $(window).width() > 930 ? '#left-nav ' : '#left-nav-phone > .mobile-nav ';

  $(activeMenu + 'li a:contains("^")').each(function(index) {
    var stringArray = $(this)
      .text()
      .split('^');
    var targetText = stringArray[1];

    $(this)
      .attr('href', '#')
      .text(targetText) // remove the caret
      .parent()
      .addClass('subHead');
  });

  $(activeMenu + 'li a:contains("~")')
    .each(function(index) {
      var stringArray = $(this)
        .text()
        .split('~');
      var targetText = stringArray[1];
      $(this)
        .text(targetText) // remove the tilde
        .parent()
        .addClass('subItem');
    })
    .promise()
    .done(function() {
      if (
        !$(activeMenu + 'li.subHead')
          .next()
          .hasClass('subGroup')
      ) {
        // if $(this).parent=== subGroup
        $(activeMenu + 'li.subHead')
          .each(function() {
            $(this)
              .nextUntil(activeMenu + 'li:not(".subItem")')
              .wrapAll("<div class='subGroup'></div>");
          })
          .promise()
          .done(function() {
            $('.subGroup').hide();
          });
      }
    });
  $(activeMenu + '.subHead a').off();
  $(activeMenu + '.subHead a').click(function(e) {
    e.stopPropagation();
    e.preventDefault();
    /* close other tabs */
    $(activeMenu + '.subHead a')
      .not(this)
      .parent()
      .removeClass('open')
      .next('.subGroup')
      .hide();
    if (
      !$(this)
        .parent()
        .hasClass('open')
    ) {
      $(this)
        .parent()
        .addClass('open')
        .next('.subGroup')
        .css('display', 'block');
    } else {
      $(this)
        .parent()
        .removeClass('open')
        .next('.subGroup')
        .css('display', 'none');
    }
    setDrawerHeight();
  });
}

// OB-3484 Header
function toggleDropdown(e) {
  const _desktopDropdown = $(this);
  const _desktopMenu = $(this).find('.desktop-dropdown-menu-hover');
  const _toggleAnchor = $(this).find('[data-toggle="dropdown"]');
  if (e.type === 'mouseover') {
    _desktopDropdown.addClass('show');
    _desktopMenu.addClass('show');
    _toggleAnchor.attr('aria-expanded', 'true');
  } else if (e.type === 'mouseout') {
    _desktopDropdown.removeClass('show');
    _desktopMenu.removeClass('show');
    _toggleAnchor.attr('aria-expanded', 'false');
  }
}

function openMobileNav() {
  $('html').addClass('nav-open');

  $(this).addClass('toggled');

  // Add div to listen to close menu click
  const bodyClick = `<div id="bodyClick"></div>`;
  $('body').append(bodyClick);
}
function closeMobileNav() {
  $('html').removeClass('nav-open');

  $('.navbar-toggler').removeClass('toggled');

  // Remove bodyclick div
  $('#bodyClick').remove();
}

function toggleSubNavs() {
  // Check if a data-target exists on the clicked element and keep its value if it does
  const target = $(this)
    .children('a')
    .attr('data-target')
    ? $(this)
        .children('a')
        .attr('data-target')
    : null;

  const $a = $(this).children('a');

  // Convert 'aria-expanded' value of anchor tag to boolean
  const isExpanded =
    $(this)
      .children('a')
      .attr('aria-expanded') == 'true';

  // Handle closing second level menus that weren't clicked
  if ($(this).hasClass('mobile-menu-child-1')) {
    $('.card-header.mobile-menu-child-1')
      .find('+ .hide')
      .not(target)
      .slideUp();

    $('.card-header.mobile-menu-child-1')
      .children('a')
      .attr('aria-expanded', 'false');
    // Handle closing top level menus that weren't clicked
  } else {
    $('.card-header')
      .find('+ .hide')
      .not(target)
      .slideUp();

    $('.card-header')
      .children('a')
      .attr('aria-expanded', 'false');
  }

  // Toggle aria-expanded attribute & hide or show menu of clicked element
  $a.attr('aria-expanded', !isExpanded);

  $(target).slideToggle();
}

function toggleFooterNavs() {
  const target = $(this).attr('data-target') ? $(this).attr('data-target') : null;
  const isExpanded = $(this).attr('aria-expanded') == 'true';

  $('#accordianFooter > a[data-target]')
    .find('+ .hide')
    .not(target)
    .slideUp();

  $('#accordianFooter > a[data-target]').attr('aria-expanded', 'false');
  $(this).attr('aria-expanded', !isExpanded);

  $(target).slideToggle();
}

// Swifttype

function hideOnClickOutside(event) {
  const $target = $(event.target);
  if (
    !$target.closest('.st-search-container, .st-ui-container').length &&
    $('.st-search-container').is(':visible')
  ) {
    closeSwiftType();
  }
}

function openSwiftType() {
  $('.st-search-container').fadeIn();
  $('#searchInputText').focus();

  document.addEventListener('click', hideOnClickOutside);
}

function closeSwiftType() {
  $('.st-search-container').fadeOut();
  document.removeEventListener('click', hideOnClickOutside);
}

$(document).on('mouseover', 'li.desktop-dropdown-hover', toggleDropdown);
$(document).on('mouseout', 'li.desktop-dropdown-hover', toggleDropdown);
$(document).on('click', '.navbar-toggler', openMobileNav);
$(document).on('click', '#bodyClick', closeMobileNav);
$(document).on('click', '.card-header', toggleSubNavs);
$(document).on('click', '#accordianFooter a[data-target]', toggleFooterNavs);
$(document).on('click', '.searchFormTrigger', openSwiftType);
$(document).on('click', '.st-search-container a[data-toggle=searchFormClose]', closeSwiftType);

// -- Hub Events -- //
const onLoadAndPageChange = function() {
  onbrandUtilityFunctions.blockCtaFix();
  expandSearch();
  dropdownOnHover();
  hubSearchPlaceholder();
  hideSearch();
  setDrawerHeight();
  thirdLevelMenu();
};

Hubs.Events.on('load', function() {
  if (!window.onbrandLoaded) {
    onLoadAndPageChange();
    // openMobileNav();
    // Add your onloads here...

    // end your onloads before here...
    window.onbrandLoaded = true;
  }
})
  .on('pageChange', function() {
    onLoadAndPageChange();
  })
  .on('itemsLoaded', function(itemIds, selectors) {})
  .on('resize', function() {
    expandSearch();
    thirdLevelMenu();
    sideCtaFix();
    addThisFix();
    closeHeaderDropdowns();
    closeMobileResourceMenu();
  })
  .on('scroll', function() {
    sideCtaFix();
    addThisFix();
    onbrandUtilityFunctions.blockCtaFix();
  })
  .on('ctaActivate', function(ctaId) {})
  .on('ctaFormSubmitSuccess', function(ctaId, mappedData, ctaName) {})
  .on('search', function() {
    hubSearchPlaceholder();
  });

//The new hub events can trigger before cihost scripts are loaded. This will ensure your scripts fire no matter what, but not more than once for 'load'.
if (!window.onbrandLoaded) {
  Hubs.Events.trigger('load');
}



// WEBPACK FOOTER //
// ./onbrand.js